import { mdiChevronRight } from '@mdi/js';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import Icon from '@mdi/react';
import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import './RequestsWidget.scss';
import { getMyapprovalsRequestCount } from '../../../store/apis/approvalService';
import * as icons from '../../../assets';

function RequestsWidget() {
  const navigate = useNavigate();
  const { pathname } = window.location;
  const isHRPath = pathname.includes('/hr');
  const { data: myApprovalsRequestCount } = useQuery({
    queryKey: ['myApprovalsRequestCount'],
    queryFn: () => getMyapprovalsRequestCount(),
    enabled: true,
  });

  return (
    <Card
      className="request-widget"
      style={{ border: '1px solid #98A2B3', borderRadius: '16px' }}
    >
      <CardHeader
        className="d-flex flex-row align-items-center gap-2 pb-0"
        style={{
          borderRadius: '8px 8px 0px 0px',
          borderBottom: 'none',
        }}
      >
        <div>
          <img
            src={icons.iconsDashboardRequests}
            alt="Request Icon"
            height="20px"
          />
        </div>
        <div style={{ fontWeight: '600', color: '#363F72' }}>
          <span className="fs-5">Requests</span>
        </div>
      </CardHeader>
      <CardBody className="request-widget-body">
        <button
          type="button"
          className="request-wrapper w-50 p-3"
          onClick={() => {
            if (isHRPath) {
              navigate('/hr/approvals?t=app');
              return;
            }
            navigate('/approvals?t=app');
          }}
          title="View requests from others that are pending your approval."
        >
          <div className="fw-semibold fs-2">
            {myApprovalsRequestCount?.myApprovalCount || 0}
          </div>
          <div
            title="View requests from others that are pending your approval."
            className="d-flex flex-row align-items-center justify-content-between w-100"
          >
            <span className="fs-5">My Approvals</span>
            <Icon path={mdiChevronRight} size={1} color="#0DA6EA" />
          </div>
        </button>

        <button
          type="button"
          className="request-wrapper w-50 p-3"
          onClick={() => {
            if (isHRPath) {
              navigate('/hr/approvals?t=req');
              return;
            }
            navigate('/approvals?t=req');
          }}
        >
          <div className="fw-semibold fs-2">
            {myApprovalsRequestCount?.myRequestCount || 0}
          </div>
          <div
            title="View the status of leave, travel, or other requests you’ve submitted."
            className="d-flex flex-row align-items-center justify-content-between w-100"
          >
            <span className="fs-5">My Requests</span>
            <Icon path={mdiChevronRight} size={1} color="#0DA6EA" />
          </div>
        </button>
      </CardBody>
    </Card>
  );
}

export default RequestsWidget;
